<section>
    <div class="page-header-area sec-overlay sec-overlay-black"
        style="background-image: url('../../../../assets/images/new-images/Inner-Banner.png'); background-repeat: no-repeat;">
        <div class="container pt--0 pb--0">
            <div class="row">
                <div class="col-12">
                    <div class="page-header-content">
                        <h2 class="title">Jobs</h2>
                        <nav class="breadcrumb-area">
                            <ul class="breadcrumb justify-content-center">
                                <li><a href="index.html">Home</a></li>
                                <li class="breadcrumb-sep">//</li>
                                <li>Jobs</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>

<section class="recent-job-area bg-color-gray">
    <div class="container aos-init aos-animate mt-2 mb-2 pt-4 pb-4" data-aos="fade-down">
        <div class="row">
            <div class="col-12">
                <div class="section-title text-center mb-4">
                    <h3 class="title">Jobs</h3>
                    <div class="desc">
                        <p>Browse the most popular jobs chosen by thousands. <br>
                            Your next big opportunity could be just a click away.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-lg-4">
                <!--== Start Recent Job Item ==-->

                <div class="recent-job-item p-3">
                    <div class="company-info card-body">
                        <div class="logo">
                            <a href="company-details.html"><img
                                    src="../../../../assets/images/new-images/OUK_Logo 1.png" width="75" height="75"
                                    alt="Image-HasTech"></a>
                        </div>
                        <div class="content">
                            <h4 class="name"><a href="company-details.html">Darkento Ltd.</a></h4>
                            <p class="address">New York, USA</p>
                        </div>
                    </div>
                    <div class="main-content">
                        <h3 class="title"><a href="job-details.html">Front-end Developer</a></h3>
                        <h5 class="work-type">Full-time</h5>
                        <p class="desc">CSS3, HTML5, Javascript, Bootstrap, Jquery</p>
                    </div>
                    <div class="recent-job-info">
                        <div class="salary">
                            <h4>$5000</h4>
                            <p>/monthly</p>
                        </div>
                        <a class="btn-theme btn-sm" href="job-details.html">Apply Now</a>
                    </div>
                </div>
                <!--== End Recent Job Item ==-->
            </div>
            <div class="col-md-6 col-lg-4">
                <!--== Start Recent Job Item ==-->

                <div class="recent-job-item p-3">
                    <div class="company-info card-body">
                        <div class="logo">
                            <a href="company-details.html"><img
                                    src="../../../../assets/images/new-images/OUK_Logo 1.png" width="75" height="75"
                                    alt="Image-HasTech"></a>
                        </div>
                        <div class="content">
                            <h4 class="name"><a href="company-details.html">Darkento Ltd.</a></h4>
                            <p class="address">New York, USA</p>
                        </div>
                    </div>
                    <div class="main-content">
                        <h3 class="title"><a href="job-details.html">Front-end Developer</a></h3>
                        <h5 class="work-type">Full-time</h5>
                        <p class="desc">CSS3, HTML5, Javascript, Bootstrap, Jquery</p>
                    </div>
                    <div class="recent-job-info">
                        <div class="salary">
                            <h4>$5000</h4>
                            <p>/monthly</p>
                        </div>
                        <a class="btn-theme btn-sm" href="job-details.html">Apply Now</a>
                    </div>
                </div>
                <!--== End Recent Job Item ==-->
            </div>
            <div class="col-md-6 col-lg-4">
                <!--== Start Recent Job Item ==-->

                <div class="recent-job-item p-3">
                    <div class="company-info card-body">
                        <div class="logo">
                            <a href="company-details.html"><img
                                    src="../../../../assets/images/new-images/OUK_Logo 1.png" width="75" height="75"
                                    alt="Image-HasTech"></a>
                        </div>
                        <div class="content">
                            <h4 class="name"><a href="company-details.html">Darkento Ltd.</a></h4>
                            <p class="address">New York, USA</p>
                        </div>
                    </div>
                    <div class="main-content">
                        <h3 class="title"><a href="job-details.html">Front-end Developer</a></h3>
                        <h5 class="work-type">Full-time</h5>
                        <p class="desc">CSS3, HTML5, Javascript, Bootstrap, Jquery</p>
                    </div>
                    <div class="recent-job-info">
                        <div class="salary">
                            <h4>$5000</h4>
                            <p>/monthly</p>
                        </div>
                        <a class="btn-theme btn-sm" href="job-details.html">Apply Now</a>
                    </div>
                </div>
                <!--== End Recent Job Item ==-->
            </div>


        </div>
    </div>
</section>